/* ORZO, warstwa „apple-design” 2026-10-17. Ruch zaczyna się od bieżącej pozycji, bierze prędkość palca
   i rzutuje ją do przodu (jak przewijanie), na brzegach stawia miękki opór. Bez tego pliku wszystko działa jak wcześniej. */
(function () {
  var d = document, still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function project(v, rate) { rate = rate || 0.998; return (v / 1000) * rate / (1 - rate); }        // v w px/s
  function rubber(over, dim, c) { c = c || 0.55; return (over * dim * c) / (dim + c * Math.abs(over)); }
  function tracker() { var h = []; return { add: function (x) { var t = performance.now(); h.push([x, t]); while (h.length > 5) h.shift(); },
    v: function () { if (h.length < 2) return 0; var a = h[0], b = h[h.length - 1], dt = (b[1] - a[1]) || 1; return (b[0] - a[0]) / dt * 1000; } }; }

  // Cień pod belką tylko wtedy, gdy treść jest pod nią
  function sc() { d.body.classList.toggle('a-sc', scrollY > 8); }
  sc(); addEventListener('scroll', sc, { passive: true });

  // Wskaźnik zakładek menu przejeżdża do wybranej
  d.querySelectorAll('.nm-tabs').forEach(function (tabs) {
    var ind = d.createElement('span'); ind.className = 'a-ind'; ind.setAttribute('aria-hidden', 'true'); tabs.appendChild(ind);
    function put() { var b = tabs.querySelector('[aria-selected="true"]'); if (!b) return; ind.style.width = b.offsetWidth + 'px'; ind.style.transform = 'translateX(' + (b.offsetLeft - tabs.scrollLeft) + 'px)'; }
    put(); addEventListener('resize', put); tabs.addEventListener('scroll', put, { passive: true });
    tabs.addEventListener('click', function () { requestAnimationFrame(put); });
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(put);
  });

  // Karuzela imprez: przeciąganie 1:1, opór na końcach, decyzja z rzutu prędkości
  d.querySelectorAll('.ne').forEach(function (s) {
    var list = s.querySelector('.ne-list'); if (!list) return;
    var tabs = s.querySelectorAll('.ne-tabs [data-ne]'); var n = tabs.length; if (n < 2) return;
    function cur() { var k = 0; tabs.forEach(function (t, i) { if (t.getAttribute('aria-selected') === 'true') k = i; }); return k; }
    function go(k, dir) { var t = tabs[(k + n) % n]; t.click(); var on = s.querySelector('.ne-i.on'); if (on && !still) { on.classList.remove('a-in-l', 'a-in-r'); void on.offsetWidth; on.classList.add(dir > 0 ? 'a-in-r' : 'a-in-l'); } }
    s.querySelectorAll('[data-ne-k]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopImmediatePropagation(); go(cur() + (+b.getAttribute('data-ne-k')), +b.getAttribute('data-ne-k')); }, true); });
    var x0 = null, y0 = 0, ph = null, tr, lock = null, w = 1;
    list.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 || e.target.closest('a,button')) return;
      ph = s.querySelector('.ne-i.on .ne-ph'); if (!ph) return;
      x0 = e.clientX; y0 = e.clientY; lock = null; w = ph.offsetWidth; tr = tracker(); tr.add(x0);
      ph.classList.remove('a-back'); list.setPointerCapture(e.pointerId);
    });
    list.addEventListener('pointermove', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      if (lock === null && Math.abs(dx) + Math.abs(dy) > 10) lock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (lock !== 'x') return;
      tr.add(e.clientX); list.classList.add('a-grab'); ph.classList.add('a-drag');
      ph.style.transform = 'translateX(' + rubber(dx, w, 0.9) + 'px)';
    });
    function end(e) {
      if (x0 === null) return;
      var dx = e.clientX - x0, v = tr.v(); x0 = null; list.classList.remove('a-grab');
      if (!ph) return; ph.classList.remove('a-drag');
      if (lock === 'x') {
        var land = dx + project(v, 0.99);
        if (Math.abs(land) > w * 0.25) { ph.style.transform = ''; go(cur() + (land < 0 ? 1 : -1), land < 0 ? 1 : -1); return; }
      }
      ph.classList.add('a-back'); ph.style.transform = '';
    }
    // w fazie przechwytywania i bez dalszego przekazania: stary obsługiwacz przesunięcia z orzo-nowy.js nie policzy gestu drugi raz
    list.addEventListener('pointerup', function (e) { end(e); e.stopPropagation(); }, true);
    list.addEventListener('pointercancel', end, true);
  });

  // Szuflada (z lewej) i panel rezerwacji (z prawej / z dołu na telefonie): zamykanie gestem
  function sheet(el, axis, sign, close) {
    if (!el) return;
    var p0 = null, other = 0, tr, lock = null, size = 1;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' || e.target.closest('a,button,input,select,textarea,label')) return;
      p0 = axis === 'x' ? e.clientX : e.clientY; other = axis === 'x' ? e.clientY : e.clientX; lock = null;
      size = axis === 'x' ? el.offsetWidth : el.offsetHeight; tr = tracker(); tr.add(p0); el.classList.remove('a-back');
    });
    el.addEventListener('pointermove', function (e) {
      if (p0 === null) return;
      var pos = axis === 'x' ? e.clientX : e.clientY, o = axis === 'x' ? e.clientY : e.clientX, dd = (pos - p0) * sign;
      if (lock === null && Math.abs(pos - p0) + Math.abs(o - other) > 10) { lock = Math.abs(pos - p0) > Math.abs(o - other) ? 'on' : 'off'; if (lock === 'on') el.setPointerCapture(e.pointerId); }
      if (lock !== 'on') return;
      tr.add(pos); el.classList.add('a-drag');
      var m = dd >= 0 ? dd : -rubber(-dd, size, 0.3);
      el.style.transform = axis === 'x' ? 'translateX(' + (m * sign) + 'px)' : 'translateY(' + (m * sign) + 'px)';
    });
    function end(e) {
      if (p0 === null) return;
      var pos = axis === 'x' ? e.clientX : e.clientY, dd = (pos - p0) * sign, v = tr.v() * sign; p0 = null;
      el.classList.remove('a-drag');
      if (lock !== 'on') { el.style.transform = ''; return; }
      if (dd + project(v, 0.99) > size * 0.35) { el.classList.add('a-back'); el.style.transform = axis === 'x' ? 'translateX(' + (sign * size) + 'px)' : 'translateY(' + (sign * size) + 'px)'; setTimeout(function () { close(); el.classList.remove('a-back'); el.style.transform = ''; }, 380); }
      else { el.classList.add('a-back'); el.style.transform = ''; }
    }
    el.addEventListener('pointerup', end); el.addEventListener('pointercancel', end);
  }
  var drwP = d.querySelector('.nd-drw .p'), x = d.getElementById('drwx');
  sheet(drwP, 'x', -1, function () { if (x) x.click(); });
  var panel = d.getElementById('rezd');
  if (panel) { var mob = matchMedia('(max-width: 760px)').matches; sheet(panel, mob ? 'y' : 'x', 1, function () { panel.close(); }); }
})();

/* Dokumenty (regulamin, polityki): spis treści z rozdziałów h2, podświetla rozdział, który czytasz. */
(function () {
  var d = document, pr = d.querySelector('.template-page .prose');
  if (!pr) return;
  var hs = pr.querySelectorAll(':scope > h2');
  if (hs.length < 3) return;
  var lang = (d.documentElement.lang || 'pl').slice(0, 2);
  var tytul = { en: 'Contents', it: 'Indice' }[lang] || 'Spis treści';
  var body = d.createElement('div'); body.className = 'a-doc-body';
  while (pr.firstChild) body.appendChild(pr.firstChild);
  var nav = d.createElement('nav'); nav.className = 'a-toc'; nav.setAttribute('aria-label', tytul);
  var ol = d.createElement('ol'), links = [];
  hs.forEach(function (h, i) {
    if (!h.id) h.id = 'r' + (i + 1);
    var li = d.createElement('li'), a = d.createElement('a');
    a.href = '#' + h.id; a.textContent = h.textContent.replace(/^\s*\d+\.\s*/, (i + 1) + '. ');
    li.appendChild(a); ol.appendChild(li); links.push(a);
  });
  var b = d.createElement('b'); b.textContent = tytul;
  nav.appendChild(b); nav.appendChild(ol);
  pr.appendChild(body); pr.appendChild(nav); pr.classList.add('a-doc');
  function mark() {
    var y = innerHeight * 0.3, k = 0;
    hs.forEach(function (h, i) { if (h.getBoundingClientRect().top < y) k = i; });
    links.forEach(function (a, i) { a.classList.toggle('on', i === k); });
  }
  mark(); addEventListener('scroll', mark, { passive: true });
})();
